import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';

import CommunitySvg from '../../../res/svg/community.svg';

const JoinCommunityComponent = (props) => {
  const { onJoinCommunity, onCancel } = props;
  return (
    <>
      <Box display="flex" justifyContent="center" my="3rem">
        <img src={CommunitySvg} alt="Community Img" />
      </Box>
      <Typography variant="h5" fontWeight="bold" textAlign="center">
        Community
      </Typography>
      <Box display="flex" flexDirection="column" gap="1rem" p="1rem">
        <Typography textAlign="justify">
          Joining your community will allow you to post for recommendations,
          community posts, marketplace items, make comments, and send messages
          to other residents in the community. Your name, photo, and building
          will be visible on the app to other residents and other residents in
          the community can send you messages. We will not display your unit or
          your private contact info.
        </Typography>
        <Box mt="1rem" />
        <Button
          variant="contained"
          onClick={onJoinCommunity}
          disableElevation
          fullWidth
        >
          Join the Community
        </Button>
        <Button color="inherit" onClick={onCancel} fullWidth>
          No thanks
        </Button>
      </Box>
    </>
  );
};

JoinCommunityComponent.propTypes = {
  onJoinCommunity: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default JoinCommunityComponent;
